import React from "react"
import FormComposer from "@components/form/components/FormComposer"
import schema, { initialValues, withRecaptcha } from "./schema"
import { SectionTypes, FieldTypes } from "@components/form/common"

interface SupportRequestProps {
  subjectOptions: string[]
  onSubmit: any
  errorMessage?: string
  isLoading: boolean
}

const SupportRequestForm: React.FC<SupportRequestProps> = ({
  subjectOptions,
  onSubmit,
  errorMessage,
  isLoading,
}) => {
  const messageFields: any = [
    {
      type: FieldTypes.TextArea,
      name: "message",
      label: "Message*",
      placeholder: "message",
    },
  ]

  const useRecaptcha = process.env.NEXT_PUBLIC_VERCEL_ENV === "production"

  if (useRecaptcha) {
    messageFields.push({
      type: FieldTypes.Recaptcha,
      name: "recaptcha",
      label: "Recaptcha",
    })
  }

  return (
    <FormComposer
      schema={useRecaptcha ? withRecaptcha : schema}
      formId="support-request-form"
      initialValues={initialValues}
      sections={[
        {
          type: SectionTypes.Column,
          label: "Contact Information",
          fields: [
            {
              type: FieldTypes.Text,
              name: "fullName",
              label: "Full Name*",
              placeholder: "Full Name",
            },
            {
              type: FieldTypes.Text,
              name: "email",
              label: "Email Address*",
              placeholder: "Email Address",
            },
            {
              type: FieldTypes.Text,
              name: "phoneNumber",
              label: "Phone Number*",
              placeholder: "Phone Number",
            },
            {
              type: FieldTypes.Text,
              name: "city",
              label: "City*",
              placeholder: "City",
            },
            {
              type: FieldTypes.Text,
              name: "stateProvince",
              label: "State or Province*",
              placeholder: "State or Province",
            },
            {
              type: FieldTypes.Text,
              name: "country",
              label: "Country*",
              placeholder: "Country",
            },
          ],
        },
        {
          type: SectionTypes.Column,
          label: "Your Message",
          fields: [
            {
              type: FieldTypes.Select,
              name: "subject",
              label: "Subject*",
              placeholder: "Subject",
              options: subjectOptions.map((option) => ({
                label: option,
                value: option,
              })),
            },
            ...messageFields,
          ],
        },
      ]}
      submitText="Send Request"
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      isLoading={isLoading}
    />
  )
}

export default SupportRequestForm
